var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5.96286 11.2779 7.1539 10.9273 8.35445 11.0126C9.55499 11.0979 10.6845 11.6134 11.5355 12.4645C12.3866 13.3155 12.9021 14.445 12.9874 15.6456C13.0727 16.8461 12.7221 18.0371 12 19M5 12C4.37902 12.4657 3.875 13.0697 3.52786 13.7639C3.18073 14.4582 3 15.2238 3 16C2.99968 16.5028 3.0752 17.0027 3.224 17.483C3.496 18.363 3.3 19.343 3.125 20.267C3.10948 20.346 3.1146 20.4276 3.13985 20.5041C3.1651 20.5805 3.20963 20.6491 3.26915 20.7033C3.32866 20.7575 3.40115 20.7954 3.4796 20.8134C3.55805 20.8314 3.63982 20.8288 3.717 20.806C4.565 20.574 5.408 20.376 6.274 20.694C6.82683 20.8968 7.41114 21.0004 8 21C8.77636 21.0008 9.5422 20.8204 10.2366 20.4732C10.931 20.126 11.5348 19.6216 12 19M5 12C5 7.315 7.875 3 13 3C14.283 2.99978 15.5471 3.30811 16.6859 3.899C17.8247 4.48988 18.8047 5.34599 19.5432 6.39508C20.2817 7.44418 20.757 8.6555 20.9291 9.92686C21.1012 11.1982 20.965 12.4923 20.532 13.7C20.056 15.026 20.569 16.802 20.869 18.268C20.8865 18.3461 20.8829 18.4274 20.8586 18.5036C20.8343 18.5798 20.7902 18.6482 20.7307 18.7017C20.6713 18.7552 20.5987 18.792 20.5204 18.8082C20.442 18.8244 20.3608 18.8195 20.285 18.794C18.973 18.384 17.433 17.808 16.2 18.328C14.866 18.89 13.464 19 12 19",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5e1b3eb2c6a21b7ba253b00ac9f294c7.svg";
export { ForwardRef as ReactComponent };